// extracted by mini-css-extract-plugin
export default {"indicator":"YWzKg7TdMq"};